export default __webpack_public_path__ + "static/media/other25.956706ff.webp";